// Sinais de rede do navegador para decidir quanto pré-carregar.
type Conn = { saveData?: boolean; effectiveType?: string };

const getConnection = (): Conn | undefined =>
  typeof navigator === "undefined" ? undefined : (navigator as any).connection;

/** Economia de dados ligada ou rede 2G: pré-carregar só o essencial. */
export function prefersReducedData(): boolean {
  const c = getConnection();
  if (!c) return false;
  return c.saveData === true || /(^|-)2g$/.test(c.effectiveType || "");
}
